import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import '../HomePage/HomeInsurance.css';
import '../HomePage/Quotes.css';
import ProposalFormDetail from "./ProposalFormDetail.jsx";
import ProposalForm from "./ProposalForm.jsx";
import HomePlan from "./HomePlan.jsx";
import { CentralCall } from "../CommonMethods/CentralCall";
import { apiURL, ckycURL } from "../index";
import CKYCHome from "../CKYCModule/CKYCHome";
import axios from "axios";
import { getKYCModel } from "./UtilityComponents/UilityFunctions";


const Proposal = () => {
    const history = useHistory();
    const location = useLocation();
    const [BtnValue, setBtnValue] = useState("Continue");
    const [QuoteReq, setQuoteReq] = useState(null);
    const [QuoteRes, setQuoteRes] = useState(null);
    const [IsLoader, setLoader] = useState(true);
    const [ProposalDetails, setProposalDetails] = useState(null);
    const [KYCObj, setKYCObj] = useState({
        IsKYCCalled: false,
        IsKycAlreadyCalled:false,
        RedirectionURL: "",
        KYCMaster: [],
        IsProposalKYC: false,
        KYCDetails: null,
        KYCStep: ""
    });
    useEffect(() => {
        const { QuoteReq, QuoteRes } = location.state;
        //console.log(QuoteReq);
        setQuoteReq(QuoteReq);
        setQuoteRes(QuoteRes);
        setLoader(false);
        const Model = {
            URL: `${apiURL}api/HomeInsurance/GetIdentificationApi`,
            Req: {
                CompanyId: QuoteRes.insurerID,
                masterType: "ckycinput"
            },
            IsPost: true
        }
        CentralCall(Model).then(Res => {
            //console.log(Res.data);
            setKYCObj(prvObj => ({ ...prvObj, KYCMaster: Res.data }));
        })
    }, []);

    const callProposal = (data) => {
        let date = new Date(data.DOB)
        let day = date.getDate()
        let finalDay = day > 9 ? day : "0" + day
        let month = date.getMonth() + 1
        let finalMonth = month > 9 ? month : "0" + month
        let year = date.getFullYear()
        let finalDate = finalDay + "-" + finalMonth + "-" + year
        setBtnValue("Please Wait..");
        const { BuildingComponent, EnquiryNo, MobileNo, DescriptionOfOccupancy } = QuoteReq;
        const { planName, policyTerm, insurerID, sumInsured, QuoteTransKey } = QuoteRes;
        const Model = {
            URL: `${apiURL}api/HomeInsurance/GetProposal`,
            Req: {
                "EnquiryNo": EnquiryNo,
                "policyTerm": policyTerm,
                "mobileno": data.MobileNo,
                "EmailID": data.Email,
                "pinCode": data.Pincode,
                "houseNumber": data.HouseNo,
                "identificationNumber": data.IdentificationNo,
                "identificationType": data.IdentificationType,
                "gender": data.Gender,
                "FullName": data.Name,
                "InsureId": insurerID,
                "dateOfBirth": finalDate,
                "areaInSqFt": BuildingComponent.areaOfBuilding,
                "SumInsured": sumInsured,
                "ratePerSqFt": Math.round(parseInt(BuildingComponent?.valueOfBuilding) / parseInt(BuildingComponent?.areaOfBuilding)) + "",
                "PlanName": planName,
                "addressType": data.Address,
                "QuoteTransKey": QuoteRes.transKey,
                BuildingComponent: QuoteReq.BuildingComponent,
                InsurerID: QuoteRes.insurerID,
                "DescriptionOfOccupancy": DescriptionOfOccupancy,
                PersonType: parseInt(data.PersonType ?? 1),
                GSTNumber: data.GSTNumber,
                NomineeName: data.NomineeName,
                NomineeRelation: data.NomineeRelation,
            },
            IsPost: true
        }

        CentralCall(Model)
            .then(Res => {
                if (Res.data.statusCode === 200) {
                    if (QuoteRes.insurerID === 124) {
                        const KYCDetails = {
                            EnquiryNo: QuoteReq.EnquiryNo,
                            TransectionID: "",
                            DOB: Model.Req.dateOfBirth,
                            Name: Model.Req.FullName,
                            Gender: Model.Req.gender,
                            Mobile: Model.Req.mobileno,
                            Email: Model.Req.EmailID,
                            CompanyID: Model.Req.InsurerID,
                            KYCCallType: QuoteRes?.kycCallType ?? "POST",
                            IsCorporate: Model.Req.PersonType == 1 ? false : true,
                            IsRenew: false,
                            Type: 0,
                            PolicyType: "0",
                            DocType: Model.Req.identificationType,
                            DocNumber: Model.Req.identificationNumber,
                            TypeOfPolicy: 0,
                            nomineeDetails: {
                                Name: Model.Req.NomineeName,
                                RelationShip: Model.Req.NomineeRelation
                            },
                            AddressDetails: {
                                PinCode: Model.Req.pinCode,
                                StateName: "",
                                CityName: "",
                                AddressLine1: Model.Req.addressType
                            },
                            FromHealth: false,
                            ProductType: 3
                        }
                        setProposalDetails({
                            ProposalReq: Model.Req,
                            ProposalRes: Res.data.response,
                            QuoteReq,
                            QuoteRes
                        })
                        // setKYCObj(prvState => ({ ...prvState, KYCDetails, IsProposalKYC: true, IsKYCCalled: true }));
                        setKYCObj(prev => ({ ...prev, KYCDetails }));
                    }
                    else {
                        history.push({
                            pathname: "/Summary",
                            state: {
                                ProposalReq: Model.Req,
                                ProposalRes: Res.data.response,
                                QuoteReq,
                                QuoteRes
                            }
                        });
                    }
                }
                else {
                    alert(Res.data.response.error);
                    setBtnValue("Continue");
                }
            }).catch(err => console.log(err.message))
    }
    const callKycApiDirect = () => {
        console.log("kycDetails", KYCObj.KYCDetails);
        const { KYCDetails } = KYCObj;
        const params = {
            KYCDetails: KYCObj.KYCDetails,
            AddressDetails: KYCDetails.AddressDetails,
            DocType: KYCDetails.DocType,
            DocID: KYCDetails.DocNumber,
            IsFileUploaded: KYCDetails?.IsFileUploaded

        }
        const kycModel = getKYCModel(params);

        CentralCall({ URL: `${ckycURL}checkckycstatus`, Req: kycModel, ExtraField: "kyc", IsPost: true }).then(Res => {
            const Response = Res.data.Response;
            if (Res.data.StatusCode === 200) {
                if (Response.CKYCStatus && KYCDetails?.KYCCallType === "POST")
                    history.push("/Summary", ProposalDetails);
            } else {
                if (Response?.Redirecturl && Response?.RedirectLink) {
                    setKYCObj(prvState => ({ ...prvState, KYCStep: "Redirection", IsProposalKYC: true, RedirectionURL: Response?.RedirectLink, IsKYCCalled: true, IsKycAlreadyCalled:true }));
                } else {
                   // alert(Response.ErrMsg);
                    setKYCObj(prvState => ({ ...prvState, IsKYCCalled: true }));
                }


            }
        }).catch(error => {
            console.log(error);
        });
    }

    useEffect(() => {
        if (KYCObj.KYCDetails !== null && KYCObj.KYCDetails !== undefined && !KYCObj.IsKYCCalled) {
            callKycApiDirect();
        }
    }, [KYCObj.KYCDetails]);

    const submitKYC = (kycUpdatedModel) => {

        const KycComponentDetails = {
            SelectedPOA: kycUpdatedModel.SelectedPOA,
            SelectedPOI: kycUpdatedModel.SelectedPOI,
            selectedPOAValue: kycUpdatedModel.selectedPOAValue,
            SelectedPOIValue: kycUpdatedModel.SelectedPOIValue,
        }

        setKYCObj(prev => ({
            ...prev,
            KYCDetails: {
                ...prev.KYCDetails,
                DocType: kycUpdatedModel.DocType,
                DocNumber: kycUpdatedModel.DocNumber,
                IsFileUploaded: kycUpdatedModel.isFileUploaded,
                CKYCStatus: kycUpdatedModel.CKYCStatus,
                CKYCID: kycUpdatedModel.CKYCID,
                CKYCRefID: kycUpdatedModel.CKYCRefID,
                KycTransKey: kycUpdatedModel.KycTransKey
            },
            KycComponentDetails,
            IsProposalKYC: true,
            IsKYCCalled: true
        }));
    }

    if (IsLoader)
        return <span>Loader</span>

    return (
        <>
            <div className="HomePerposalPage HomePageMain">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="backtoquotes">
                                <a className="go_backToQuotes" onClick={() => history.goBack()}>
                                    <i className="fa fa-chevron-left"></i>
                                    <span>Back to Quotation</span>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-9 Proposal1">
                            <ProposalFormDetail QuoteReq={QuoteReq} QuoteRes={QuoteRes} />
                        </div>
                        <div className="col-lg-3 Proposal1 Sticky-Column">
                            <HomePlan QuoteRes={QuoteRes} QuoteReq={QuoteReq} />
                        </div>
                        <div className="col-lg-9 Proposal1">
                            <ProposalForm BtnValue={BtnValue} stateData={{ ...QuoteReq, ...QuoteRes }} KYCMaster={KYCObj.KYCMaster} onProposalSubmit={callProposal} />
                        </div>
                    </div>
                </div>
            </div>
            {KYCObj.IsKYCCalled && <CKYCHome Redirection={KYCObj.RedirectionURL} IsKycAlreadyCalled={KYCObj.IsKycAlreadyCalled} KycCallType={"POST"} ProposalData={ProposalDetails} KYCErrorMsg={""} IsProposalKYC={KYCObj.IsProposalKYC} KYCDetails={KYCObj.KYCDetails} onKycSubmit={submitKYC} step={KYCObj.KYCStep} CompanyID={QuoteRes.insurerID} EnquiryNo={QuoteReq?.EnquiryNo} CKYCData={KYCObj.KYCMaster} closeKYC={() => { setKYCObj(prvState => ({ ...prvState, IsKYCCalled: false, IsProposalKYC: false })); setBtnValue("Continue") }} />}
        </>
    );
}

export default Proposal;